import { useCallback } from 'react';
import type { NavigateFunction } from 'react-router-dom';
import { buildDetailRecordFunctionPayload, type HeliosFunctionContext } from 'utils/helios/buildHeliosFunctionPayload';
import type { HeliosFunctionCallRecordValue } from 'types/dataHelios';
import { useHeliosFunctionRunner } from './useHeliosFunctionRunner';
import type { FunctionModalConfirmData } from 'components/user/DummyHelios/Functions/modals/FunctionModal';

interface UseHeliosDetailRecordFunctionsProps {
  datasourceId: string;
  templateViewId: string;
  moduleId: string;
  childModuleId?: string;
  recordId: string;
  masterRecordId: string;
  getColumnValues: () => Record<string, string | null>;
  getRecordValues?: () => HeliosFunctionCallRecordValue[] | undefined;
  navigate: NavigateFunction;
  getNavigateState?: () => Record<string, unknown> | undefined;
  onSuccess?: () => void | Promise<void>;
}

export const useHeliosDetailRecordFunctions = ({
  datasourceId,
  templateViewId,
  moduleId,
  childModuleId,
  recordId,
  masterRecordId,
  getColumnValues,
  getRecordValues,
  navigate,
  getNavigateState,
  onSuccess,
}: UseHeliosDetailRecordFunctionsProps) => {
  const buildPayload = useCallback(
    (args: { context: HeliosFunctionContext; request?: FunctionModalConfirmData['request'] }) =>
      buildDetailRecordFunctionPayload({
        ...args,
        datasourceId,
        recordId,
        masterRecordId,
        getColumnValues,
      }),
    [datasourceId, getColumnValues, masterRecordId, recordId]
  );

  return useHeliosFunctionRunner({
    templateViewId,
    moduleId,
    childModuleId,
    navigate,
    getNavigateState,
    buildPayload,
    onSuccess,
    getRecordValues,
  });
};
